export default __webpack_public_path__ + "static/err-d5cb54775648e7cd14e4006feb5714c2.svg";